module.exports = "/assets/data/a97b529391c4f6de260d31ef4eb81dcb-CM7.data.json";